import React from 'react';
import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/admin/partners', end: true, label: 'Partners' },
  { to: '/admin/partners/applications', label: 'Applications' },
  { to: '/admin/partners/tiers', label: 'Tiers' },
  { to: '/admin/partners/client-links', label: 'Client Link Audit' },
  { to: '/admin/partners/payouts', label: 'Payouts' },
];

export default function PartnersSubNav() {
  return (
    <div className="admin-tabs">
      {TABS.map(({ to, end, label }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) => `admin-tab${isActive ? ' active' : ''}`}
        >
          {label}
        </NavLink>
      ))}
    </div>
  );
}
